import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Badge } from 'components/qstrap'

const DesktopMenuItem = ({
  link,
  text,
  onClick,
  isNew,
  className: classNameProps,
  filled,
  currentUser,
  border,
}) => {
  const className = classNames(
    'nav-link',
    {
      filled,
      'log-in': currentUser,
      'with-border': border,
    },
    classNameProps
  )

  return (
    <>
      <li className="nav-item hidden-md-down">
        <a className={className} href={link} onClick={onClick}>
          {text}
          {isNew && <Badge className="new-badge">NEW!</Badge>}
        </a>
      </li>

      <style jsx>{`
        .with-border {
          display: flex;
          width: 100px;
          justify-content: center;
          border: 1px solid;
          border-radius: 4px;
        }
        
        .filled {
          background-color: #00c2c9;
          color: #fff !important;
        }

        .log-in {
          color: #08b4e1 !important;
        }

      `}
      </style>
    </>
  )
}

DesktopMenuItem.propTypes = {
  link: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  isNew: PropTypes.bool,
  className: PropTypes.string,
  filled: PropTypes.bool,
  border: PropTypes.bool,
}

DesktopMenuItem.defaultProps = {
  isNew: false,
  filled: false,
  border: false,
}

export default DesktopMenuItem
